import { motion } from 'motion/react';
import {
  type FC, type ReactNode,
} from 'react';
import { usePrevious } from '~/_shared/utils/hooks/usePrevious';
import { useHeightTransition } from './useHeightTransition';

type HeightTransitionProps = Readonly<{
  children: ReactNode;
  animateOnMount: boolean;
}>;

export const HeightTransitionComponent: FC<HeightTransitionProps> = ({ children, animateOnMount }) => {
  const [wrapperElementRef, contentHeight] = useHeightTransition();
  const previousContentHeight = usePrevious(contentHeight);

  const immediate = (previousContentHeight === undefined && !animateOnMount)
    || previousContentHeight === contentHeight;

  return (
    <motion.div
      style={{ overflow: 'hidden' }}
      initial={{
        height: previousContentHeight ?? 0,
      }}
      animate={{
        height: contentHeight ?? 0,
      }}
      transition={immediate ? { duration: 0 } : { duration: 0.25, ease: 'easeInOut' }}
    >
      <div
        ref={el => {
          wrapperElementRef.current = el;
        }}
      >
        {children}
      </div>
    </motion.div>
  );
};
